class ValidaSpedNfeModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'FileUploader', 'contrato', 'ferramenta']

  constructor: ($injector, @modalInstance, FileUploader, contrato, @ferramenta) ->
    super($injector)

    @uploader = new FileUploader(
      url: '/api/eficiencia-fiscal/valida-sped'
      headers: cbk.getHeaders()
      formData: [
        {contrato: contrato.id}
      ]
    )

    @result = undefined;

    @uploader.onCompleteItem = (fileItem, response, status, headers) =>
      @result = response

  importar: ->
    @result = undefined;
    @uploader.uploadAll()

  cancel: ->
    @modalInstance.close(new Retorno(false))


angular.module("eficienciaFiscalModule").controller('validaNfeSpedModalController', ValidaSpedNfeModalController)